import React from 'react';

function LeftPanel({ children }: { children: React.ReactNode }) {
  return (
    <div className="col-lg-4 col-md-5 d-flex align-items-stretch">
      <div className="info-wrap bg-primary w-100 p-md-5 p-4">
        {children}
      </div>
    </div>
  );
}

export default LeftPanel;